module.exports = __webpack_public_path__ + "static/media/sw5.cf88e04e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/street wear/sw5.jpg
// module id = 528
// module chunks = 0